/**
 * Mode mapper for converting between frontend and backend product quantity type formats
 */

export const BACKEND_TO_FRONTEND_MODE: Record<string, string> = {
  RATE_PER_AREA: 'ratePerAcre',
  TOTAL_PRODUCT: 'totalProduct',
  RATE_PER_TANK: 'ratePerTank'
};

export const FRONTEND_TO_BACKEND_MODE: Record<string, string> = {
  ratePerAcre: 'RATE_PER_AREA',
  totalProduct: 'TOTAL_PRODUCT',
  ratePerTank: 'RATE_PER_TANK'
};

/**
 * Converts a backend mode value to frontend format
 * @param backendMode - The backend mode string (e.g., 'RATE_PER_AREA')
 * @returns The frontend mode string (e.g., 'ratePerAcre') or the original value if no mapping exists
 */
export const convertBackendToFrontendMode = (
  backendMode?: string
): string | undefined => {
  if (!backendMode) return backendMode;
  return BACKEND_TO_FRONTEND_MODE[backendMode] || backendMode;
};

/**
 * Converts a frontend mode value to backend format
 * @param frontendMode - The frontend mode string (e.g., 'ratePerAcre')
 * @returns The backend mode string (e.g., 'RATE_PER_AREA') or the original value if no mapping exists
 */
export const convertFrontendToBackendMode = (
  frontendMode?: string
): string | undefined => {
  if (!frontendMode) return frontendMode;
  return FRONTEND_TO_BACKEND_MODE[frontendMode] || frontendMode;
};
